import { client } from './client';

export const taskApi = {
  getAssignees: () => client.get('task_assignees'),
  createDraft: () => client.get('task_create_draft'),
  updateDraft: (data) => client.post('task_update_draft', data),
  sendFile: (data) => client.post('task_send_file', data),
  deleteFile: (params) => client.get('task_delete_file', { params }),
  deleteDraft: (task_id) => client.get('task_delete_draft', { params: { task_id } }),
  send: (task_id) => client.post('task_send', { task_id }),
  list: (params) => client.get('task_list', { params }),
  get: (task_id) => client.get('task_get', { params: { task_id } }),
  respond: (data) => client.post('task_respond', data),
  review: (data) => client.post('task_review', data),
  deadlineAlerts: () => client.get('task_deadline_alerts'),
  getExtraMembers: () => client.get('task_extra_members'),
  saveExtraMembers: (employee_ids) => client.post('task_save_extra_members', { employee_ids }),
};
